var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7532 6.94737H8.93507L9.14286 1.05263C9.14286 0.421053 8.72727 0 8.1039 0C7.68831 0 7.06494 0.421053 7.06494 1.05263L6.85714 6.94737L1.03896 7.15789C0.415584 7.15789 0 7.57895 0 8.21053C0 8.84211 0.415584 9.26316 1.03896 9.26316L6.85714 9.05263L6.64935 14.9474C6.64935 15.5789 7.06493 16 7.68831 16C8.31169 16 8.72727 15.5789 8.72727 14.9474L8.93507 8.8421L14.961 8.63158C15.5844 8.63158 16 8.21053 16 7.57895C15.7922 7.36842 15.3766 6.73684 14.7532 6.94737Z",
    fill: "#808285"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.1df1c60f545ef7028a07256c4ed51c18.svg";
export { ForwardRef as ReactComponent };